module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-main"
  }, [_vm._m(0), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main-wrap"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "main-item"
    }, [_c('div', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.ticket_name
      }
    }, [_vm._v(_vm._s(item.ticket_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.ticket_amount))]), _vm._v(" "), _c('div', {
      staticClass: "overhide",
      attrs: {
        "title": item.remark
      }
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-head"
  }, [_c('div', [_vm._v("罚单编号")]), _vm._v(" "), _c('div', [_vm._v("罚单日期")]), _vm._v(" "), _c('div', [_vm._v("罚单类型")]), _vm._v(" "), _c('div', [_vm._v("快币金额(币)")]), _vm._v(" "), _c('div', [_vm._v("处罚原因")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-89f15726!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/ticketTable.vue
// module id = 772
// module chunks = 1